"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetStyles = void 0;
const core = __importStar(require("../../core"));
exports.WidgetStyles = core.serialization.object({
    base: core.serialization.string().optional(),
    baseHover: core.serialization.property("base_hover", core.serialization.string().optional()),
    baseActive: core.serialization.property("base_active", core.serialization.string().optional()),
    baseBorder: core.serialization.property("base_border", core.serialization.string().optional()),
    baseSubtle: core.serialization.property("base_subtle", core.serialization.string().optional()),
    basePrimary: core.serialization.property("base_primary", core.serialization.string().optional()),
    baseError: core.serialization.property("base_error", core.serialization.string().optional()),
    accent: core.serialization.string().optional(),
    accentHover: core.serialization.property("accent_hover", core.serialization.string().optional()),
    accentActive: core.serialization.property("accent_active", core.serialization.string().optional()),
    accentBorder: core.serialization.property("accent_border", core.serialization.string().optional()),
    accentSubtle: core.serialization.property("accent_subtle", core.serialization.string().optional()),
    accentPrimary: core.serialization.property("accent_primary", core.serialization.string().optional()),
    overlayPadding: core.serialization.property("overlay_padding", core.serialization.number().optional()),
    buttonRadius: core.serialization.property("button_radius", core.serialization.number().optional()),
    inputRadius: core.serialization.property("input_radius", core.serialization.number().optional()),
    bubbleRadius: core.serialization.property("bubble_radius", core.serialization.number().optional()),
    sheetRadius: core.serialization.property("sheet_radius", core.serialization.number().optional()),
    compactSheetRadius: core.serialization.property("compact_sheet_radius", core.serialization.number().optional()),
    dropdownSheetRadius: core.serialization.property("dropdown_sheet_radius", core.serialization.number().optional()),
});
